import { render, staticRenderFns } from "./PdfDrawingsView.vue?vue&type=template&id=50409a20&scoped=true&"
import script from "./PdfDrawingsView.vue?vue&type=script&lang=js&"
export * from "./PdfDrawingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50409a20",
  null
  
)

export default component.exports